import { doc, onSnapshot } from 'firebase/firestore'
import { ref, watchEffect } from 'vue'
import firebase from '../../firebase'

const getDocument = (collectionName, documentId) => {
  const error = ref('')
  const document = ref(null)
  const loading = ref(true)

  const unsubscribe = onSnapshot(
    doc(firebase.db, collectionName, documentId),
    (doc) => {
      document.value = { id: doc.id, ...doc.data() }
      error.value = ''
      loading.value = false
    },
    (err) => {
      document.value = null
      error.value = err.message
      loading.value = false
    }
  )

  watchEffect((onInvalidate) => {
    onInvalidate(() => unsubscribe())
  })

  return { error, document, loading }
}

export default getDocument